import * as ServiceIcons from "./service-icons";
import Doctor1 from "../../../asset/logo-and-service/Bs CK1 _ Vũ Văn Phấn.png";
import Doctor2 from "../../../asset/logo-and-service/DSC_8630.png";
import Doctor3 from "../../../asset/logo-and-service/DSC_8661.png";
import Doctor4 from "../../../asset/logo-and-service/DSC_8857.png";
import Customer1 from "../../../asset/logo-and-service/customer-1.jpg";
import Customer2 from "../../../asset/logo-and-service/customer-2.jpg";
import Customer3 from "../../../asset/logo-and-service/customer-3.jpg";
import Customer4 from "../../../asset/logo-and-service/customer-4.jpg";
import Customer5 from "../../../asset/logo-and-service/customer-5.jpg";

export const fixedServices = [
  {
    name: "Nhổ răng khôn",
    firstImage: ServiceIcons.ServiceIcon1,
    secondImage: ServiceIcons.ServiceIcon2,
    description:
      "Vì sao phải nhổ răng khôn, răng chỉ định phải nhổ khác? Cần nhổ răng khôn để tránh những biến chứng như viêm nhiễm răng lân cận, tiêu viêm xương, u nang, nhiễm trùng. Phòng tránh biến chứng khe bị giắt thức ăn giữa răng khôn và răng bên cạnh. Tương lai ảnh...",
  },
  {
    name: "Tẩy trắng răng",
    firstImage: ServiceIcons.ServiceIcon3,
    secondImage: ServiceIcons.ServiceIcon4,
    description:
      "Tẩy trắng răng như nào? Và khi nào nên tẩy trắng răng? Nhiều khách hàng có nhu cầu khi đến Nha Khoa Phấn Hoa còn băn khoăn không biết tẩy trắng răng có tốt hay không? Hay có an toàn không? hãy cùng tham khảo bài viết sau của Bác Sỹ tại Nha Khoa Phấn Hoa. Th...",
  },
  {
    name: "Trồng răng Implant",
    firstImage: ServiceIcons.ServiceIcon5,
    secondImage: ServiceIcons.ServiceIcon6,
    description:
      "Trồng răng bằng chất liệu gì? Phương pháp nào là tốt nhất, hiện đại nhất? Nha khoa ngày nay sở hữu công nghệ cấy ghép Implant là một thành tựu vĩ đại của khoa học nhân loại. Đã giúp việc thay thế những chiếc răng đã mất không còn là cơn ác mộng ngoài kỹ thuật...",
  },
  {
    name: "Trám răng - Chữa tủy",
    firstImage: ServiceIcons.ServiceIcon7,
    secondImage: ServiceIcons.ServiceIcon8,
    description:
      "Mất toàn hàm cũng là một trong những bài toán khó khi Implant chưa ra đời. Vì phục hình tháo ra lắp vào không có ưu điểm vững ổn và ngăn ngừa tình trang tiêu xương. Implant có đủ tố chất là Vững ổn, ngăn ngừa tiêu xương, cố định trên khung xương hàm bằng liên...",
  },
  {
    name: "Bọc răng sứ",
    firstImage: ServiceIcons.ServiceIcon9,
    secondImage: ServiceIcons.ServiceIcon10,
    description:
      "Bọc răng sứ mang lại giá trị thẩm mỹ cao cho hàm răng và khuôn mặt của bạn, giúp răng chống biến màu hiệu quả. Có độ bền cao, cố định trên cung hàm, phục hồi chức năng ăn nhai tốt, cải thiện giọng nói, bảo tồn răng thật...",
  },
  {
    name: "Niềng răng",
    firstImage: ServiceIcons.ServiceIcon11,
    secondImage: ServiceIcons.ServiceIcon12,
    description:
      "Niềng răng - Nắn chỉnh (hay còn gọi là niềng, cài chỉnh nha) là một khí cụ được sử dụng trong nha khoa chỉnh nha tại Nha Khoa Phấn Hoa. Để làm thẳng răng mọc khấp khểnh, đưa chúng về đúng với vị trí trên khớp cắn, đồng thời cải thiện sức khỏe răng miệng...",
  },
];

export const doctorList = [
  {
    image: Doctor1,
    doctorName: "Dr. Vũ Văn Phấn",
    doctorPosition: "Bác sĩ chuyên khoa",
  },
  {
    image: Doctor2,
    doctorName: "Dr. Duy",
    doctorPosition: "Bác sĩ chuyên khoa",
  },
  {
    image: Doctor3,
    doctorName: "Dr. Nguyễn Văn Linh",
    doctorPosition: "Bác sĩ chuyên khoa",
  },
  {
    image: Doctor4,
    doctorName: "Nguyễn Ngọc Tuyên",
    doctorPosition: "Điều dưỡng trưởng",
  },
];
export const reviews = [
  {
    avatar: Customer1,
    reviewerName: "Nguyễn Hà Anh",
    reviewerJob: "Nhân viên kinh doanh",
    description:
      "Nha khoa rộng rãi, thoáng mát. Cơ sở vật chất hiện đại. Đội ngũ nhân viên chu đáo nhiệt tình, rất đáng để trải nghiệm.",
  },
  {
    avatar: Customer4,
    reviewerName: "Hoài Liên",
    reviewerJob: "Nhà đầu tư",
    description:
      "Một nụ cười đẹp mang lại rất nhiều năng lượng tích cực. Tôi cảm nhận rõ rệt được điều đó. Cảm ơn đội ngũ y bắc sỹ của Nha Khoa Phấn Hoa.",
  },
  {
    avatar: Customer2,
    reviewerName: "Phạm Ngọc Hồng",
    reviewerJob: "Youtuber",
    description:
      "Bây giờ thì mình đã tự tin selfie dù vẫn đang trong quá trình niềng răng bởi nó cũng khá là thời trang nha. Thanks Nha Khoa Phấn Hoa.",
  },
  {
    avatar: Customer3,
    reviewerName: "Thúy Candy",
    reviewerJob: "Giáo viên",
    description:
      "Trước đến giờ mình chẳng bao giờ dám cười tươi, từ ngày đến Nha Khoa Phấn Hoa thì thực sự đó chẳn còn là vấn đề nữa rồi.",
  },
  {
    avatar: Customer5,
    reviewerName: "Phương Thị Thu Thảo",
    reviewerJob: "Nhân viên bán hàng",
    description:
      "Được người bạn thân giới thiệu đến Nha Khoa Phấn Hoa em thấy hoàn toàn hài lòng về dịch vụ cũng như chất lượng. Đặc biệt cảm mến các bác sỹ tại nha khoa. Em xin cảm ơn các bác sĩ.",
  },
];
export const coreValues = [
  {
    title: "Tâm",
    content:
      "Lấy đạo đức và tâm của con người làm gốc rễ để phát triển bền vững trong lĩnh vực y tế.",
  },
  {
    title: "Trí",
    content: "Điều trị bằng trí tuệ và khối óc của các Bác Sĩ Chuyên Khoa.",
  },
  {
    title: "Tín",
    content:
      "Coi trọng và bảo vệ uy tín với khách hàng về chất lượng,tiến độ và các cam kết trong dịch vụ y tế.",
  },
  {
    title: "Tầm",
    content:
      "Với tầm nhìn và sứ mệnh được xác định rõ ràng giúp thu hút nhân tài đồng hành, cống hiến cùng Doanh Nghiệp. Đầu tư khoa học, hiện đại, bài bản mang tầm vóc Quốc Tế.",
  },
];

export const vision = [
  {
    content:
      "Phát triển hệ thống y tế với quy mô, trí tuệ và dịch vụ đi đầu khu vực.",
  },
  { content: "Xây dựng hệ thống để nhân bản rộng khắp cả nước." },
  {
    content:
      "Tiên phong số 1 về công nghệ trong điều trị, thẩm mỹ nha khoa tại Việt Nam và trên toàn Thế giới.",
  },
];

export const mission = [
  { content: "Chăm sóc, bảo vệ và gìn giữ từng đơn vị răng của người Việt" },
  {
    content:
      "Cam kết mang đến cho các khách hàng sự hài lòng về chất lượng dịch vụ cũng như chất lượng sản phẩm.",
  },
];

export const prestige = [
  {
    title: "Uy tín",
    content:
      "Đảm bảo chất lượng sản phẩm tốt nhất. Tuân thủ thời gian điều trị chính xác. Làm việc và vận hành có hệ thống chuẩn. Mối quan hệ win-win đôi bên cùng có lợi.",
  },
  {
    title: "Dẫn đầu",
    content:
      "Luôn đầu tư công nghệ tiên tiến bậc nhất nhất trên thế giới. Đặt mục tiêu chất lượng hàng đầu. Mang lại các trải nghiệm tốt nhất tới các khách hàng.",
  },
];

export const solidarity = [
  {
    title: "Đoàn kết",
    content:
      "Cùng chung mục tiêu, chí hướng. Luôn vì mình và vì mọi người. Luôn có tinh thần hợp tác. Không đối kháng - Tôn trọng lẫn nhau.",
  },
  {
    title: "Trách nhiệm",
    content:
      "Luôn chịu trách nhiệm với hành động của mình. Không đổ lỗi - Không bao biện. Hoàn thành công việc tới cùng.",
  },
];

export const creative = [
  {
    content:
      "Luôn tìm tòi, học hỏi, phát huy tính sáng tạo. Luôn động viên, khuyến khích ý tưởng mới. Cập nhật và học tập các kiến thức mới, công nghệ mới.",
  },
];


